import { RouterModule } from '@angular/router';
import { NotificationsComponent } from './notifications.component';

export const NotificationsRoutesModule = RouterModule.forChild([
    {
        path: '',
        component: NotificationsComponent,
        data: {
            alias: 'notifications.index',
            breadcrumb: 'Notifications',
            reload: false
        },
        children: [
            {
                path: ':notificationId',
                component: NotificationsComponent,
                data: {
                    alias: 'notifications.details',
                    reload: false,
                    breadcrumb: 'Notifications details'
                }
            }
        ]
    }
]);
